import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const RegisterPage = () => {
  const { t } = useLanguage();

  return (
    <div className="landing-container">
      {/* Hero Section */}
      <section className="landing-hero">
        <div className="landing-hero-content">
          {/* Badge */}
          <div className="landing-badge">
            {t('registerBadge')}
          </div>

          {/* Title */}
          <h1 className="landing-title">
            Lingua<span className="accent">DE</span>
          </h1>

          {/* Subtitle */}
          <p className="landing-subtitle">
            {t('registerSubtitle')}
          </p>

          <div className="landing-form-container">
            <h2 className="landing-form-title">
              {t('register')}
            </h2>
            <p className="landing-form-subtitle">
              {t('registrationTemporarilyUnavailable')}
            </p>

            <div className="landing-divider" />

            <div className="landing-form-footer">
              {t('alreadyHaveAccount')}{' '}
              <a href="/login">
                {t('login')}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
